import React from "react";
import KineticHero from "../components/KineticHero";
import FeaturedCollection from "../components/FeaturedCollection";
import SixPackBuilder from "../components/SixPackBuilder";
import ManifestoChapters from "../components/ManifestoChapters";
import EditorialMarquee from "../components/EditorialMarquee";
import FarmersMarketSection from "../components/FarmersMarketSection";
import ReviewsCarousel from "../components/ReviewsCarousel";

export default function Home() {
  return (
    <div data-testid="home-page">
      <KineticHero />
      <FeaturedCollection />
      <SixPackBuilder />
      <ManifestoChapters />
      <EditorialMarquee />
      <FarmersMarketSection />
      <ReviewsCarousel />
    </div>
  );
}
